import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Keeps the address bar on the canonical trailing-slash form.
 *
 * The production host 308-redirects every path to its trailing-slash version,
 * so that form is the real address and is what canonicals, hreflang links and
 * the sitemaps declare. Client-side navigations bypass the host, so an old
 * non-slash link (a shared /en/resort/niseko-hirafu URL, an internal Link)
 * would otherwise leave the browser and any crawler on the pre-redirect URL.
 * Rewriting it in place — no re-render, no extra history entry — makes the
 * visible URL match the canonical everywhere.
 */
export function TrailingSlashRedirect() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (pathname === '/' || pathname.endsWith('/')) return;
    // Asset-looking paths (/data.json, /image.png) are served as files.
    if (/\.[a-z0-9]{2,5}$/i.test(pathname)) return;

    window.history.replaceState(window.history.state, '', `${pathname}/${search}${hash}`);
  }, [pathname, search, hash]);

  return null;
}
